var app = angular.module("leonardo");

var OnDemandCategoriesController = function($scope, ngDialog, $state, OnDemandCategoryService, AccountUserService,
                                            FilterService, AuthDataService, $controller, PermissionService,
                                            ConfigThemeService) {

  $scope.permissionService = PermissionService;
  $scope.authDataService = AuthDataService;
  $scope.configThemeService = ConfigThemeService;

  $scope.showCloneAdminDialog = function (category) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/admin/clone-element.html',
      controller: 'CloneTypeDialog',
      className: 'ngdialog-theme-default ngdialog-select-account',
      data: {
        onlyClientInstance: true,
        type: 'on demand category',
      }
    }).then(function (result) {
      if (result.type_result === 'client_instance') {
        category.cloneToWhiteLabel({clientinstances: result.client_instance}).then(function () {
          $scope.loadPage($scope.page);
        });
      }
    });
  };

  $scope.showOnDemandDeleteDialog = function(item) {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/on-demand-instructions/delete.html',
      controller: 'OnDemandDeleteDialog',
      data: {
        item: item,
        type: 'category',
        message: 'Are you sure you want to delete this category? All content in this category library will be deleted and the action cannot be undone.'
      }
    }).then(function() {
      OnDemandCategoryService.updateCollection(item, true);
    });
  };

  $scope.goToForm = function(item) {
    $state.go('on-demand-instructions.category-edit', {pk: item.id});
  };

  $scope.getEntitiesPromise = function(options) {
    options['search'] = FilterService.getFilter('search');
    options['client_instance'] = FilterService.getFilter('client_instances', true);
    if (AuthDataService.isNotStaff()) {
      var account = null;
      if(AccountUserService.currentAccountUser && AccountUserService.currentAccountUser.account){
        account = AccountUserService.currentAccountUser.account.id || AccountUserService.currentAccountUser.account
      }
      if (isNull(account)) {
        account = FilterService.accounts.length > 0 ? FilterService.accounts[0].id : null;
      }
      options['account'] = account;
    }
    return OnDemandCategoryService.getlist(options);
  };

  $scope.goToItem = function(item) {
    $state.go('on-demand-instructions.category', {pk: item.id});
  };

  $scope.$on('on-demand-instruction:updated', function(){
    $scope.loadPage($scope.page);
  });

  $controller('TableFilterController', { $scope: $scope });

  $scope.loadPage(1);

};

app.controller('OnDemandCategoriesController', ['$scope', 'ngDialog', '$state', 'OnDemandCategoryService',
  'AccountUserService', 'FilterService', 'AuthDataService', '$controller', 'PermissionService', 'ConfigThemeService',
  OnDemandCategoriesController]);
